import React from "react";
import { Form, Popover, Upload } from "antd";
import UploadUtils from "../../utilities/uploadUtils";
import SortDraggableList from "../SortDraggableList";
import { QuestionCircleOutlined } from "@ant-design/icons";

const AboutAffiliationSort = ({ data, setData, form }) => {
  const affiliationItems =
    data?.affiliations?.map((item, index) => ({
      id: index.toString(),
      ...item,
    })) || [];

  const renderAffiliationContent = (field) => (
    <Form.Item
      label={
        <span>
          Affiliation Image{" "}
          <Popover
            placement="right"
            title="W * H"
            content="200 x 105"
          >
            <QuestionCircleOutlined />
          </Popover>
        </span>
      }
      name={[field.name, "affiliation_image"]}
      {...UploadUtils.formItemProps}
      wrapperCol={{ span: 24 }}
    >
      <Upload {...UploadUtils.buttonPreviewProps}>
        <UploadUtils.CardContent />
      </Upload>
    </Form.Item>
  );

  return (
    <SortDraggableList
      items={affiliationItems}
      renderContent={renderAffiliationContent}
      setData={setData}
      form={form}
      formField="affiliations"
      addContent={false}
      showRemoveOption={false}
      cardTitle="Affiliation"
    />
  );
};

export default AboutAffiliationSort;
